<template>
    <span style="width: 1082px">
        <span v-for="index in pageCount" :key="`page-index_${index}`" :style="index > 1 ? 'page-break-before: always; break-before: page;' : ''">
            <table :style="[css.workOrderTable]" style="width: 100%">
                <tbody>
                    <!-- MAX cols 15 per row -->
                    <tr :style="[css.tr]">
                        <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]">Tootmistellimuse nr</td>
                        <td colspan="3" :style="[css.td, css.paddingBig, css.colorPurple]">
                            <v-text-field
                                v-if="editMode && roles && roles.includes(roleSA)"
                                :value="activeWorkOrder.production_order_number"
                                @input="updateWorkOrder($event, 'production_order_number')"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                                step="1"
                            ></v-text-field>
                            <span v-else>{{ activeWorkOrder.production_order_number || "-" }}</span>
                        </td>

                        <td v-if="isPackingLineNumber" :style="[css.td, css.paddingBig, css.colorGray]">
                            Pakkimise kuupäev
                        </td>
                        <td v-else :style="[css.td, css.paddingBig, css.colorGray]">Tootmise kuupäev</td>

                        <td :style="[css.td, css.paddingBig, css.colorPurple]">
                            <v-menu
                                v-if="editMode && roles && roles.includes(roleSA)"
                                ref="productionDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        style="width: 120px"
                                        solo-inverted
                                        dense
                                        :value="productionDateValue"
                                        readonly
                                        hide-details
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="productionDate"
                                    mode="date"
                                    first-day-of-week="1"
                                    @input="$refs.productionDateMenu.isActive = false"
                                ></v-date-picker>
                            </v-menu>
                            <span v-else>{{ getProductionDate() || "-" }}</span>
                        </td>

                        <td rowspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Eeldatav kestus</td>
                        <td :style="[css.td, css.paddingBig, css.colorPurple]">
                            <v-text-field
                                v-if="editMode && roles && roles.includes(roleSA)"
                                :value="activeWorkOrder.estimated_time"
                                @input="updateWorkOrder($event, 'estimated_time')"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                                step="1"
                            ></v-text-field>
                            <span v-else>{{ activeWorkOrder.estimated_time || "-" }}</span>
                        </td>

                        <template v-if="isMultiLineOrder && !isFryerWithPackingWorkOrderSecondPage(index)">
                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Planeeritud kogus kg</td>

                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorPurple]">
                                <v-text-field
                                    v-if="editMode && roles && roles.includes(roleSA)"
                                    :value="
                                        (isMultiLineOrder
                                            ? activeWorkOrder.planned_quantity_secondary
                                            : activeWorkOrder.planned_quantity) ?? null
                                    "
                                    @input="
                                        updateWorkOrder(
                                            $event,
                                            isMultiLineOrder ? 'planned_quantity_secondary' : 'planned_quantity'
                                        )
                                    "
                                    dense
                                    hide-details
                                    flat
                                    @keypress="onlyIntegersWithComma"
                                    class="text-field-item"
                                    solo-inverted
                                    step="1"
                                ></v-text-field>
                                <span v-else>
                                    {{
                                        (isMultiLineOrder
                                            ? activeWorkOrder.planned_quantity_secondary
                                            : activeWorkOrder.planned_quantity) || "-"
                                    }}
                                </span>
                            </td>
                        </template>
                        <template v-else-if="isFryerOnlyWorkOrder || isFryerWithPackingWorkOrderSecondPage(index)">
                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Planeeritud kogus kg</td>
                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorPurple]">
                                <v-text-field
                                    v-if="editMode && roles && roles.includes(roleSA)"
                                    :value="!isFryerWithPackingWorkOrderSecondPage(index) ? parseInt(activeWorkOrder.planned_quantity) : parseInt(activeWorkOrder.planned_quantity_secondary)"
                                    @input="updateWorkOrder($event, !isFryerWithPackingWorkOrderSecondPage(index) ? 'planned_quantity' : 'planned_quantity_secondary')"
                                    dense
                                    hide-details
                                    flat
                                    @keypress="onlyIntegersWithComma"
                                    class="text-field-item"
                                    solo-inverted
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ !isFryerWithPackingWorkOrderSecondPage(index) ? activeWorkOrder.planned_quantity : activeWorkOrder.planned_quantity_secondary || "-" }}</span>
                            </td>
                        </template>
                        <template v-else>
                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Planeeritud kogus</td>
                            <td colspan="1" :style="[css.td, css.paddingBig, css.colorPurple]">
                                <v-text-field
                                    v-if="editMode && roles && roles.includes(roleSA)"
                                    :value="parseInt(activeWorkOrder.planned_quantity)"
                                    @input="updateWorkOrder($event, 'planned_quantity')"
                                    dense
                                    hide-details
                                    flat
                                    @keypress="onlyIntegersWithComma"
                                    class="text-field-item"
                                    solo-inverted
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ activeWorkOrder.planned_quantity || "-" }}</span>
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray]">tk</td>
                        </template>

                        <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray, css.width200]" v-if="!isFryerWithPackingWorkOrderSecondPage(index)">Partii / BB</td>

                        <td v-if="isFryerOnlyWorkOrder || isFryerWithPackingWorkOrderSecondPage(index)" :style="[css.td, css.paddingBig, css.colorGray, css.width50]" :colspan="isFryerWithPackingWorkOrderSecondPage(index) ? 2 : 1">
                            Vahetuse nr. 1-7
                        </td>
                        <td v-else :style="[css.td, css.paddingBig, css.colorGray, css.width50]">Vahetuse nr. 1-4</td>
                    </tr>
                    <tr :style="[css.tr]">
                        <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]">Toodetav partii</td>
                        <td colspan="3" :style="[css.td, css.paddingBig, css.colorPurple]">
                            <v-text-field
                                v-if="editMode && roles && roles.includes(roleSA)"
                                :value="activeWorkOrder.production_batch_number"
                                @input="updateWorkOrder($event, 'production_batch_number')"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                                step="1"
                            ></v-text-field>
                            <span v-else>{{ activeWorkOrder.production_batch_number || "-" }}</span>
                        </td>

                        <td v-if="isPackingLineNumber" :style="[css.td, css.paddingBig, css.colorGray]">
                            Pakkimise algusaeg
                        </td>
                        <td v-else :style="[css.td, css.paddingBig, css.colorGray]">Tootmise algusaeg</td>
                        <td :style="[css.td, css.paddingBig, css.colorPurple]">
                            <time-input
                                v-if="editMode && roles && roles.includes(roleSA)"
                                v-model="activeWorkOrder.production_time"
                            />
                            <span v-else>{{ activeWorkOrder.production_time || "-" }}</span>
                        </td>

                        <td :style="[css.td, css.paddingBig, css.colorPurple]">{{ getEstimationTime("long", true) }}</td>

                        <template v-if="isMultiLineOrder && !isFryerWithPackingWorkOrderSecondPage(index)">
                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Planeeritud kogus tk</td>

                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorPurple]">
                                <v-text-field
                                    v-if="editMode && roles && roles.includes(roleSA)"
                                    :value="parseInt(activeWorkOrder.planned_quantity)"
                                    @input="updateWorkOrder($event, 'planned_quantity')"
                                    dense
                                    hide-details
                                    flat
                                    @keypress="onlyIntegersWithComma"
                                    class="text-field-item"
                                    solo-inverted
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ activeWorkOrder.planned_quantity || "-" }}</span>
                            </td>
                        </template>
                        <template v-else>
                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Müügitellimuse nr</td>
                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorPurple]">
                                <v-text-field
                                    v-if="editMode && roles && roles.includes(roleSA)"
                                    :value="activeWorkOrder.sales_order_number"
                                    @input="updateWorkOrder($event, 'sales_order_number')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ activeWorkOrder.sales_order_number || "-" }}</span>
                            </td>
                        </template>

                        <!--                    <td :style="[css.td, css.paddingBig, css.colorGray]"></td>-->
                        <td
                            :colspan="isFryerWithPackingWorkOrderSecondPage(index) ? 3 : 2"
                            :rowspan="isMultiLineOrder && !isFryerWithPackingWorkOrderSecondPage(index) ? 2 : 1"
                            :style="[css.td, css.paddingBig, css.colorYellow]"
                        >
                            <v-text-field
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                :value="activeWorkOrder.combo_field_with_batch_date_and_number"
                                @input="updateWorkOrder($event, 'combo_field_with_batch_date_and_number')"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                                step="1"
                            ></v-text-field>
                            <span v-else>{{
                                isPdfView && !activeWorkOrder.combo_field_with_batch_date_and_number
                                    ? ""
                                    : activeWorkOrder.combo_field_with_batch_date_and_number || "-"
                            }}</span>
                        </td>
                        <td v-if="!isFryerWithPackingWorkOrderSecondPage(index)"
                            :rowspan="isMultiLineOrder && !isFryerWithPackingWorkOrderSecondPage(index) ? 2 : 1"
                            :style="[css.td, css.paddingBig, css.colorYellow]">
                            <v-text-field
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                :value="activeWorkOrder.shift_number"
                                @input="updateWorkOrder($event, 'shift_number')"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                                step="1"
                            ></v-text-field>
                            <span v-else>{{
                                isPdfView && !activeWorkOrder.shift_number ? "" : activeWorkOrder.shift_number || "-"
                            }}</span>
                        </td>
                    </tr>

                    <tr v-if="isMultiLineOrder && !isFryerWithPackingWorkOrderSecondPage(index)">
                        <td colspan="8"></td>
                        <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Müügitellimuse nr</td>
                        <td colspan="2" :style="[css.td, css.paddingBig, css.colorPurple]">
                            <v-text-field
                                v-if="editMode && roles && roles.includes(roleSA)"
                                :value="activeWorkOrder.sales_order_number"
                                @input="updateWorkOrder($event, 'sales_order_number')"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                                step="1"
                            ></v-text-field>
                            <span v-else>{{ activeWorkOrder.sales_order_number || "-" }}</span>
                        </td>
                    </tr>

                    <tr :style="[css.tr]">
                        <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]">Toote kood</td>
                        <td :style="[css.td, css.paddingBig, css.colorPurple]">
                            {{ activeWorkOrder.product_code || "-" }}
                        </td>

                        <td :style="[css.td, css.paddingBig, css.colorGray]" colspan="2">Toote nimi</td>
                        <td :style="[css.td, css.paddingBig, css.colorPurple]" :colspan="7">
                            <v-autocomplete
                                v-if="editMode && roles && roles.includes(roleSA)"
                                :items="products"
                                :value="activeWorkOrder.product_name"
                                @input="updateWorkOrderProduct($event)"
                                :item-text="(item) => `[${item.code}] ${item.name}`"
                                item-value="name"
                                id="searchInput"
                                :placeholder="t('Name')"
                                flat
                                solo-inverted
                                hide-details
                                dense
                            >
                            </v-autocomplete>
                            <span v-else>{{ getName(activeWorkOrder.product_name) || "-" }}</span>
                        </td>
                        <!--                    <td-->

                        <!--                        v-if="!isToasterWorkOrder && !isFryerWithPackingWorkOrder && !isFryerOnlyWorkOrder"-->
                        <!--                        :style="[css.td, css.paddingBig, css.colorPurple]"-->
                        <!--                    ></td>-->
                        <td :style="[css.td, css.paddingBig, css.colorGray]">Toote EAN</td>
                        <td colspan="3" :style="[css.td, css.paddingBig, css.colorPurple]">
                            {{ activeWorkOrder.product_ean || "-" }}
                        </td>
                    </tr>

                    <tr :style="[css.tr]" v-if="isMultiLineOrder">
                        <template v-if="isToasterWithPackingWorkOrder">
                            <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray]">
                                Liininumber POPCORNI TOOTMINE
                            </td>
                            <td class="" colspan="2" :style="[css.td, css.paddingBig, css.colorOrange]">
                                {{ isToaster1LineNumber ? "Röster 1" : "Röster 2" }}
                            </td>

                            <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray]">Liininumber PAKKIMINE</td>
                            <td class="" colspan="1 " :style="[css.td, css.paddingBig, css.colorOrange]">Polaris 3</td>
                        </template>

                        <template v-else>
                            <template v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))">
                                <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray]">Liininumber</td>
                                <td class="" colspan="4" :style="[css.td, css.paddingBig, css.colorOrange]">
                                    <v-select
                                        :value="activeWorkOrder.line_number"
                                        @change="updateWorkOrder($event, 'line_number')"
                                        dense
                                        hide-details
                                        flat
                                        class="text-field-item"
                                        solo-inverted
                                        :items="fryerWithPackingLineNumbers"
                                    ></v-select>
                                </td>
                            </template>

                            <template v-else>
                                <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray]">Liininumber PRAADIMINE</td>
                                <td class="" colspan="2" :style="[css.td, css.paddingBig, css.colorOrange]">
                                    Praadimisliin
                                </td>

                                <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray]">Liininumber PAKKIMINE</td>
                                <td class="" colspan="1 " :style="[css.td, css.paddingBig, css.colorOrange]">
                                    {{ getPackingLineNumberText(activeWorkOrder.line_number) }}
                                </td>

                                <template v-if="isFryerWithPackingWorkOrderSecondPage(index)">
                                    <td colspan="2"  :style="[css.td, css.paddingBig, css.colorGray]">
                                        Ühe pooltoote kasti kaal (kg)
                                    </td>

                                    <td class="" colspan="3" :style="[css.td, css.paddingBig, css.colorYellow]">
                                        <span>{{ isPdfView && !activeWorkOrder.intermediate_product_bag_weight
                                            ? ""
                                            : activeWorkOrder.intermediate_product_bag_weight || "-" }}</span>
                                    </td>
                                </template>
                            </template>
                        </template>
                        <template v-if="!isFryerWithPackingWorkOrderSecondPage(index)">
                            <td :style="[css.td, css.paddingBig, css.colorGray]">Kleebis</td>
                            <td :style="[css.td, css.paddingBig, css.colorOrange]">
                                <v-select
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                    :value="activeWorkOrder.sticker"
                                    @change="updateWorkOrder($event, 'sticker')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    :items="trueFalseItems"
                                ></v-select>
                                <span v-else>{{ activeWorkOrder.sticker ? "Jah" : "Ei" }}</span>
                            </td>

                            <td :style="[css.td, css.paddingBig, css.colorGray]">Gaasiga pakkimine</td>
                            <td :style="[css.td, css.paddingBig, css.colorOrange]">
                                <v-select
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                    :value="activeWorkOrder.gas_packing"
                                    @change="updateWorkOrder($event, 'gas_packing')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    :items="trueFalseItems"
                                ></v-select>
                                <span v-else>{{ activeWorkOrder.gas_packing ? "Jah" : "Ei" }}</span>
                            </td>

                            <td :style="[css.td, css.paddingBig, css.colorGray]">Pakke kastis</td>
                            <td colspan="1" :style="[css.td, css.paddingBig, css.colorOrange]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                    :value="activeWorkOrder.bags_in_box"
                                    @input="updateWorkOrder($event, 'bags_in_box')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @keypress="onlyIntegersWithComma"
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ activeWorkOrder.bags_in_box || "-" }}</span>
                            </td>

                            <td :style="[css.td, css.paddingBig, css.colorGray]">Kaste alusel</td>
                            <td :style="[css.td, css.paddingBig, css.colorOrange, css.minWidth100]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                    :value="activeWorkOrder.boxes_on_pallet"
                                    @input="updateWorkOrder($event, 'boxes_on_pallet')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @keypress="onlyIntegersWithComma"
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ activeWorkOrder.boxes_on_pallet || "-" }}</span>
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray]">BB</td>
                            <td :style="[css.td, css.paddingBig, css.colorOrange, css.minWidth100]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                    :value="activeWorkOrder.best_before"
                                    @input="updateWorkOrder($event, 'best_before')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>{{ activeWorkOrder.best_before || "-" }}</span>
                            </td>
                        </template>
                    </tr>
                    <tr :style="[css.tr]" v-else>
                        <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray]">Liininumber</td>
                        <td class="" colspan="4" :style="[css.td, css.paddingBig, css.colorOrange]">
                            <v-select
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                :value="activeWorkOrder.line_number"
                                @change="updateWorkOrder($event, 'line_number')"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                                :items="workOrderLineNumbers"
                            ></v-select>
                            <span v-else>{{ getLineNumberText(activeWorkOrder.line_number) }}</span>
                        </td>
                        <template v-if="isToasterLineNumber || isFryerOnlyWorkOrder">
                            <td colspan="2" v-if="isFryerOnlyWorkOrder" :style="[css.td, css.paddingBig, css.colorGray]">
                                Ühe pooltoote kasti kaal (kg)
                            </td>
                            <td colspan="2" v-else :style="[css.td, css.paddingBig, css.colorGray]">
                                Ühe pooltoote koti kaal (kg)
                            </td>

                            <td class="" colspan="3" :style="[css.td, css.paddingBig, css.colorYellow]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="activeWorkOrder.intermediate_product_bag_weight"
                                    @input="updateWorkOrder($event, 'intermediate_product_bag_weight')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    step="1"
                                    @keypress="onlyIntegersWithComma"
                                    @focusout="handleIntermediateProductsProducedFocusout"
                                ></v-text-field>
                                <span v-else>{{ isPdfView && !activeWorkOrder.intermediate_product_bag_weight
                                            ? ""
                                            : activeWorkOrder.intermediate_product_bag_weight || "-" }}</span>
                            </td>
                        </template>
                        <template v-else>
                            <td :style="[css.td, css.paddingBig, css.colorGray]">Kleebis</td>
                            <td :style="[css.td, css.paddingBig, css.colorOrange]">
                                <v-select
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                    :value="activeWorkOrder.sticker"
                                    @change="updateWorkOrder($event, 'sticker')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    :items="trueFalseItems"
                                ></v-select>
                                <span v-else>{{ activeWorkOrder.sticker ? "Jah" : "Ei" }}</span>
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray]">Gaasiga pakkimine</td>
                            <td :style="[css.td, css.paddingBig, css.colorOrange]">
                                <v-select
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                    :value="activeWorkOrder.gas_packing"
                                    @change="updateWorkOrder($event, 'gas_packing')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    :items="trueFalseItems"
                                ></v-select>
                                <span v-else>{{ activeWorkOrder.gas_packing ? "Jah" : "Ei" }}</span>
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray]">Pakke kastis</td>
                            <td colspan="1" :style="[css.td, css.paddingBig, css.colorOrange]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                    :value="activeWorkOrder.bags_in_box"
                                    @input="updateWorkOrder($event, 'bags_in_box')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @keypress="onlyIntegersWithComma"
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ activeWorkOrder.bags_in_box || "-" }}</span>
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray]">Kaste alusel</td>
                            <td :style="[css.td, css.paddingBig, css.colorOrange, css.minWidth100]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                    :value="activeWorkOrder.boxes_on_pallet"
                                    @input="updateWorkOrder($event, 'boxes_on_pallet')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @keypress="onlyIntegersWithComma"
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ activeWorkOrder.boxes_on_pallet || "-" }}</span>
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray]">BB</td>
                            <td :style="[css.td, css.paddingBig, css.colorOrange, css.minWidth100]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                    :value="activeWorkOrder.best_before"
                                    @input="updateWorkOrder($event, 'best_before')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>{{ activeWorkOrder.best_before || "-" }}</span>
                            </td>
                        </template>
                    </tr>
                    <tr :style="[css.tr]" class="padding-big" v-if="false">
                        <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]" colspan="2">
                            Vastutavad operaatorid
                        </td>
                        <td
                            v-for="(operator, operatorIndex) in activeWorkOrder.operators"
                            :colspan="calculateColspanLength(operatorIndex, activeWorkOrder.operators)"
                            :style="[css.td, css.paddingBig, css.colorOrange]"
                        >
                            <div
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                style="display: flex"
                            >
                                <v-combobox
                                    :items="operatorOptions(operator.name)"
                                    :value="operator.name"
                                    @input="updateWorkOrderResponsibleOperator($event, 'name', operatorIndex)"
                                    item-text="name"
                                    item-value="name"
                                    id="searchInput"
                                    class="mt-6 mx-2"
                                    :placeholder="t('Name')"
                                    flat
                                    solo-inverted
                                    dense
                                >
                                </v-combobox>
                                <v-btn icon @click="handleRemoveOperator(operatorIndex)">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </div>

                            <span v-else>{{ getName(operator.name) || "-" }}</span>
                        </td>
                        <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))">
                            <v-btn
                                dark
                                small
                                color="bal-red"
                                class="px-1 ml-2"
                                style="min-width: 0"
                                @click.stop="addNewOperator"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </td>
                    </tr>
                    <tr :style="[css.tr]" v-else-if="isMultiLineOrder">
                        <template v-if="isToasterWithPackingWorkOrder">
                            <td :style="[css.td, css.colorGray]" colspan="2">
                                Vastutav Operaator <br />
                                POPCORNI TOOTMINE
                            </td>
                        </template>
                        <template v-else>
                            <td :style="[css.td, css.colorGray]" colspan="2">
                                Vastutav Operaator <br />
                                PRAADIMISLIIN
                            </td>
                        </template>

                        <td :style="[css.td, css.colorOrange]" colspan="3">
                            <v-combobox
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                :items="operatorOptions(secondaryOperator)"
                                :value="secondaryOperator"
                                @input="
                                    updateWorkOrderResponsibleOperator(
                                        $event,
                                        'name',
                                        null,
                                        WorkOrderCategories.CATEGORY_SECONDARY
                                    )
                                "
                                item-text="name"
                                item-value="name"
                                id="searchInput"
                                class="my-2 mx-2"
                                :placeholder="t('Name')"
                                flat
                                solo-inverted
                                dense
                                hide-details
                            >
                            </v-combobox>
                            <span v-else>
                                {{ secondaryOperator ? getName(secondaryOperator.name) : "-" }}
                            </span>
                        </td>

                        <td rowspan="2" :style="[css.td, css.colorGray]">Liinitöötajad</td>
                        <td
                            v-for="(lineWorker, lineWorkerIndex) in activeWorkOrder.line_workers"
                            :colspan="calculateColspanLength(lineWorkerIndex, activeWorkOrder.line_workers)"
                            :style="[css.td, css.colorOrange]"
                            rowspan="2"
                        >
                            <div
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                style="display: flex"
                            >
                                <v-combobox
                                    :items="lineWorkerOptions(lineWorker)"
                                    :value="lineWorker.name"
                                    @input="updateWorkOrderLineWorker($event, 'name', lineWorkerIndex)"
                                    item-text="name"
                                    item-value="name"
                                    item-disabled="disabled"
                                    id="searchInput"
                                    class="my-2 mx-2"
                                    :placeholder="t('Name')"
                                    flat
                                    solo-inverted
                                    dense
                                    hide-details
                                >
                                </v-combobox>
                                <v-btn icon @click="handleRemoveLineWorker(lineWorkerIndex)">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </div>

                            <span v-else>{{ getName(lineWorker.name) || "-" }}</span>
                        </td>
                        <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))" rowspan="2">
                            <v-btn
                                dark
                                small
                                color="bal-red"
                                class="px-1 ml-2"
                                style="min-width: 0"
                                @click.stop="addNewLineWorker()"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </td>
                    </tr>

                    <tr :style="[css.tr]" class="padding-big" v-else>
                        <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]" colspan="2">
                            Vastutav operaator
                        </td>
                        <td :style="[css.td, css.paddingBig, css.colorOrange]" colspan="3">
                            <v-combobox
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                :items="operatorOptions(primaryOperator)"
                                :value="primaryOperator"
                                @input="updateWorkOrderResponsibleOperator($event, 'name', null)"
                                item-text="name"
                                item-value="name"
                                id="searchInput"
                                class="mt-6 mx-2"
                                :placeholder="t('Name')"
                                flat
                                solo-inverted
                                dense
                            >
                            </v-combobox>
                            <span v-else>{{
                                primaryOperator ? getName(primaryOperator.name) : "-"
                            }}</span>
                        </td>
                        <td :style="[css.td, css.paddingBig, css.colorGray]">Liinitöötajad</td>
                        <td
                            v-for="(lineWorker, lineWorkerIndex) in activeWorkOrder.line_workers"
                            :colspan="calculateColspanLength(lineWorkerIndex, activeWorkOrder.line_workers)"
                            :style="[css.td, css.paddingBig, css.colorOrange]"
                        >
                            <div
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                style="display: flex"
                            >
                                <v-combobox
                                    :items="lineWorkerOptions(lineWorker)"
                                    :value="lineWorker.name"
                                    @input="updateWorkOrderLineWorker($event, 'name', lineWorkerIndex)"
                                    item-text="name"
                                    item-value="name"
                                    item-disabled="disabled"
                                    id="searchInput"
                                    class="mt-6 mx-2"
                                    :placeholder="t('Name')"
                                    flat
                                    solo-inverted
                                    dense
                                >
                                </v-combobox>
                                <v-btn icon @click="handleRemoveLineWorker(lineWorkerIndex)">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </div>

                            <span v-else>{{ getName(lineWorker.name) || "-" }}</span>
                        </td>
                        <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))">
                            <v-btn
                                dark
                                small
                                color="bal-red"
                                class="px-1 ml-2"
                                style="min-width: 0"
                                @click.stop="addNewLineWorker()"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </td>
                    </tr>

                    <tr :style="[css.tr]" class="padding-big" v-if="!isMultiLineOrder && (studentOperators.length > 0 || (editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))))">
                        <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]" colspan="2">
                            Õpilane operaator
                        </td>
                        <td
                            v-for="(studentOp, studentOpIndex) in studentOperators"
                            :key="`student-op-${studentOpIndex}`"
                            :colspan="calculateColspanLength(studentOpIndex, studentOperators, 13)"
                            :style="[css.td, css.paddingBig, css.colorOrange]"
                        >
                            <div
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                style="display: flex"
                            >
                                <v-combobox
                                    :items="operatorOptions(studentOp)"
                                    :value="studentOp"
                                    @input="updateWorkOrderStudentOperator($event, 'name', studentOpIndex)"
                                    item-text="name"
                                    item-value="name"
                                    id="searchInput"
                                    class="mt-6 mx-2"
                                    :placeholder="t('Name')"
                                    flat
                                    solo-inverted
                                    dense
                                >
                                </v-combobox>
                                <v-btn icon @click="handleRemoveStudentOperator(studentOpIndex)">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </div>
                            <span v-else>{{ getName(studentOp.name) || "-" }}</span>
                        </td>
                        <td
                            v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS)) && studentOperators.length < 2"
                            :colspan="studentOperators.length === 0 ? 11 : undefined"
                        >
                            <v-btn
                                dark
                                small
                                color="bal-red"
                                class="px-1 ml-2"
                                style="min-width: 0"
                                @click.stop="addNewStudentOperator()"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </td>
                    </tr>

                    <tr :style="[css.tr]" v-if="isMultiLineOrder">
                        <td :style="[css.td, css.colorGray]" colspan="2">
                            Vastutav Operaator <br />
                            POLARIS PAKKEMASIN
                        </td>
                        <td :style="[css.td, css.colorOrange]" colspan="3">
                            <v-combobox
                                :items="operatorOptions(primaryOperator)"
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                :value="primaryOperator"
                                @input="updateWorkOrderResponsibleOperator($event, 'name', null)"
                                item-text="name"
                                item-value="name"
                                id="searchInput"
                                class="my-2 mx-2"
                                :placeholder="t('Name')"
                                flat
                                solo-inverted
                                dense
                                hide-details
                            >
                            </v-combobox>

                            <span v-else>
                                {{ primaryOperator ? getName(primaryOperator.name) : "-" }}
                            </span>
                        </td>
                    </tr>

                    <tr :style="[css.tr]" v-if="isMultiLineOrder && (studentOperators.length > 0 || (editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))))">
                        <td :style="[css.td, css.paddingBig, css.colorGray]" colspan="2">
                            Õpilane operaator
                        </td>
                        <td
                            v-for="(studentOp, studentOpIndex) in studentOperators"
                            :key="`student-op-multi-${studentOpIndex}`"
                            :colspan="calculateColspanLength(studentOpIndex, studentOperators, 13)"
                            :style="[css.td, css.paddingBig, css.colorOrange]"
                        >
                            <div
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                style="display: flex"
                            >
                                <v-combobox
                                    :items="operatorOptions(studentOp)"
                                    :value="studentOp"
                                    @input="updateWorkOrderStudentOperator($event, 'name', studentOpIndex)"
                                    item-text="name"
                                    item-value="name"
                                    id="searchInput"
                                    class="my-2 mx-2"
                                    :placeholder="t('Name')"
                                    flat
                                    solo-inverted
                                    dense
                                    hide-details
                                >
                                </v-combobox>
                                <v-btn icon @click="handleRemoveStudentOperator(studentOpIndex)">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </div>
                            <span v-else>
                                {{ getName(studentOp.name) || "-" }}
                            </span>
                        </td>
                        <td
                            v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS)) && studentOperators.length < 2"
                            :colspan="studentOperators.length === 0 ? 3 : undefined"
                        >
                            <v-btn
                                dark
                                small
                                color="bal-red"
                                class="px-1 ml-2"
                                style="min-width: 0"
                                @click.stop="addNewStudentOperator()"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </td>
                    </tr>

                    <tr :style="[css.tr]" class="padding-big" v-if="false">
                        <td :style="[css.td, css.paddingBig, css.colorGray]" colspan="2">Liinitöötajad</td>
                        <td
                            v-for="(lineWorker, lineWorkerIndex) in activeWorkOrder.line_workers"
                            :colspan="calculateColspanLength(lineWorkerIndex, activeWorkOrder.line_workers)"
                            :style="[css.td, css.paddingBig, css.colorOrange]"
                        >
                            <div
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))"
                                style="display: flex"
                            >
                                <v-combobox
                                    :items="lineWorkerOptions(lineWorker)"
                                    :value="lineWorker.name"
                                    @input="updateWorkOrderLineWorker($event, 'name', lineWorkerIndex)"
                                    item-text="name"
                                    item-value="name"
                                    item-disabled="disabled"
                                    id="searchInput"
                                    class="mt-6 mx-2"
                                    :placeholder="t('Name')"
                                    flat
                                    solo-inverted
                                    dense
                                >
                                </v-combobox>
                                <v-btn icon @click="handleRemoveLineWorker(lineWorkerIndex)">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </div>

                            <span v-else>{{ getName(lineWorker.name) || "-" }}</span>
                        </td>
                        <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleHOS))">
                            <v-btn
                                dark
                                small
                                color="bal-red"
                                class="px-1 ml-2"
                                style="min-width: 0"
                                @click.stop="addNewLineWorker()"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </td>
                    </tr>

                    <tr :style="[css.tr]" v-if="!isPdfView || (isPdfView && (isToasterLineNumber || isPackingLineNumber))">
                        <td colspan="15"></td>
                    </tr>

                    <template
                        v-if="
                            !isToasterLineNumber &&
                            !isPackingLineNumber &&
                            !isFryerWithPackingWorkOrder &&
                            !isFryerOnlyWorkOrder
                        "
                    >
                        <tr>
                            <td :style="[css.td, css.colorGray]" colspan="2">Retsept RS-16</td>
                            <td :style="[css.td, css.colorPurple]" colspan="3"><span v-if="isRecipeRs16Case">X</span></td>
                            <td :style="[css.td, css.colorGray]" colspan="1" rowspan="2">Segude arv</td>
                            <td :style="[css.td, css.colorYellow]" colspan="2" rowspan="2">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    v-model="numberOfMixes"
                                    @input="onNumberOfMixesChange"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ numberOfMixes || "-" }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td :style="[css.td, css.colorGray]" colspan="2">Retsept RS-17</td>
                            <td :style="[css.td, css.colorPurple]" colspan="3"><span v-if="isRecipeRs17Case">X</span></td>
                        </tr>
                    </template>

                    <tr :style="[css.tr]">
                        <td :style="[css.td, css.colorGray]" colspan="6">Koostisosad</td>
                        <td :style="[css.td, css.colorGray]" colspan="2">Partii</td>
                        <td :style="[css.td, css.colorGray]" colspan="2">Eeldatav kulu</td>
                        <td :style="[css.td, css.colorGray]">Tegelik kulu</td>
                        <td :style="[css.td, css.colorGray]">Mõõtühik</td>
                        <td :style="[css.td, css.colorGray]" colspan="3">Partiivahetuse kellaaeg</td>
                        <td v-if="editMode && roles && roles.includes(roleSA)">
                            <v-btn
                                dark
                                small
                                color="bal-red"
                                class="px-1 mb-2 ml-1"
                                style="min-width: 0"
                                @click.stop="addNewIngredient"
                            >
                                <v-icon>add</v-icon>
                            </v-btn>
                        </td>
                    </tr>

                    <tr
                        :style="[css.tr]"
                        v-for="(item, ingredientIndex) in activeWorkOrder.ingredients"
                        :key="`ingredient_${ingredientIndex}`"
                    >
                        <td :style="[css.td, css.colorPurpleIngredientTable]">{{ item.product_code || "-" }}</td>
                        <td :style="[css.td, css.colorPurpleIngredientTable, { maxWidth: '270px' }]" colspan="5">
                            <v-autocomplete
                                v-if="editMode && roles && roles.includes(roleSA)"
                                :items="materials"
                                :value="item.product_name"
                                @input="updateWorkOrderIngredient($event, 'item', ingredientIndex)"
                                :item-text="(iItem) => `[${iItem.code}] ${iItem.name}`"
                                item-value="name"
                                return-object
                                id="materialSearchInput"
                                :placeholder="t('Name')"
                                flat
                                solo-inverted
                                hide-details
                                dense
                            >
                            </v-autocomplete>

                            <span v-else> {{ item.product_name || "-" }} </span>
                        </td>
                        <td :style="[css.td, css.colorPurpleIngredientTable]" colspan="2">
                            <v-text-field
                                v-if="editMode && roles && roles.includes(roleSA)"
                                :value="item.product_batch"
                                @input="updateWorkOrderIngredient($event, 'product_batch', ingredientIndex)"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                            ></v-text-field>
                            <span v-else>{{ item.product_batch || "" }}</span>
                        </td>
                        <td :style="[css.td, css.colorPurpleIngredientTable]" colspan="2">
                            <v-text-field
                                v-if="editMode && roles && roles.includes(roleSA)"
                                :value="item.estimated_quantity"
                                @input="updateWorkOrderIngredient($event, 'estimated_quantity', ingredientIndex)"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                                @keypress="onlyIntegersWithComma"
                            ></v-text-field>
                            <span v-else>{{ item.estimated_quantity || "" }}</span>
                        </td>
                        <td :style="[css.td, css.colorYellow, css.minWidth100]">
                            <v-text-field
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                :value="item.actual_quantity"
                                @input="updateWorkOrderIngredient($event, 'actual_quantity', ingredientIndex)"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                                @keypress="onlyIntegersWithComma"
                                step="1"
                            ></v-text-field>
                            <span v-else>
                                {{ isPdfView && !item.actual_quantity ? "" : item.actual_quantity || "0.000" }}
                            </span>
                        </td>
                        <td :style="[css.td, css.colorPurpleIngredientTable]">
                            <v-text-field
                                v-if="editMode && roles && roles.includes(roleSA)"
                                :value="item.product_unit"
                                @input="updateWorkOrderIngredient($event, 'product_unit', ingredientIndex)"
                                dense
                                hide-details
                                flat
                                class="text-field-item"
                                solo-inverted
                            ></v-text-field>
                            <span v-else>{{ item.product_unit || "" }}</span>
                        </td>
                        <td
                            :style="batchChangeTimeCellCss(ingredientIndex)"
                            colspan="3"
                            :rowspan="batchChangeTimeCellRowspan(ingredientIndex)"
                            @click="makeBatchChangeTimeEditable(ingredientIndex)"
                        >
                            <v-row
                                class="mx-3"
                                v-if="
                                    editMode &&
                                    roles &&
                                    (roles.includes(roleSA) || roles.includes(roleOperator)) &&
                                    item.batch_change_time
                                "
                            >
                                <v-text-field
                                    :value="item.batch_change_time"
                                    @input="updateWorkOrderIngredient($event, 'batch_change_time', ingredientIndex)"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item pr-1"
                                    pattern="^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$"
                                    type="time"
                                    solo-inverted
                                ></v-text-field>
                                <v-btn class="pl-1" icon @click.stop="deleteBatchChangeTime(ingredientIndex)">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </v-row>
                            <span v-else>
                                {{
                                    (isPdfView && item.batch_change_time === "00:00") || !item.batch_change_time
                                        ? ""
                                        : item.batch_change_time || "00:00"
                                }}
                            </span>
                        </td>
                        <td v-if="editMode && roles && roles.includes(roleSA)">
                            <v-btn icon @click="handleRemoveIngredient(ingredientIndex)">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </td>
                    </tr>

                    <tr :style="[css.tr]" v-if="(isPdfView && (isToasterLineNumber || isPackingLineNumber)) || !isPdfView">
                        <td colspan="15"></td>
                    </tr>

                    <template v-if="isPdfView && isToasterLineNumber && !isToasterWithPackingWorkOrder">
                        <tr :style="[css.tr]">
                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">
                                Maisitera kogus punkris vahetusraporti alguses (kg)
                            </td>
                            <td colspan="1" :style="[css.td, css.paddingBig, css.colorGray]"></td>

                            <td colspan="3" :style="[css.td, css.paddingBig, css.colorGray]">
                                Lisatud maisitera kogus vahetusraporti jooksul (kg)
                            </td>
                            <td colspan="4" :style="[css.td, css.paddingBig, css.colorGray]"></td>

                            <td colspan="3" :style="[css.td, css.paddingBig, css.colorGray]">
                                Maisitera kogus punkris vahetusraporti lõpus (kg)
                            </td>
                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]"></td>
                        </tr>

                        <tr :style="[css.tr]">
                            <td colspan="15"></td>
                        </tr>
                    </template>

                    <tr :style="[css.tr]">
                        <template v-if="(isToasterLineNumber && !isToasterWithPackingWorkOrder) || isFryerWithPackingWorkOrderSecondPage(index)">
                            <td :style="[css.td, css.paddingBig, css.colorGray]">Toodetud kogus POOLTOODE KOTID, TK</td>

                            <td colspan="9" :style="[css.td, css.paddingBig, css.colorYellow]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="activeWorkOrder.intermediate_product_bags_produced"
                                    @input="updateWorkOrder($event, 'intermediate_product_bags_produced')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @focusout="handleIntermediateProductsProducedFocusout"
                                ></v-text-field>
                                <span v-else>
                                    {{
                                        isPdfView && !activeWorkOrder.intermediate_product_bags_produced
                                            ? ""
                                            : activeWorkOrder.intermediate_product_bags_produced || "-"
                                    }}
                                </span>
                            </td>
                        </template>

                        <template v-else-if="isFryerOnlyWorkOrder">
                            <td :style="[css.td, css.paddingBig, css.colorGray]">Toodetud kogus POOLTOOTE KASTID TK</td>
                            <td colspan="9" :style="[css.td, css.paddingBig, css.colorYellow]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="activeWorkOrder.total_pallets_produced"
                                    @input="updateWorkOrder($event, 'total_pallets_produced')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    @focusout="handleTotalPalletsProducedFocusout"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>
                                    {{
                                        isPdfView && !activeWorkOrder.total_pallets_produced
                                            ? ""
                                            : activeWorkOrder.total_pallets_produced || "-"
                                    }}
                                </span>
                            </td>
                        </template>
                        <template v-else>
                            <td v-if="isPackingLineNumber" :style="[css.td, css.paddingExtraBig, css.colorGray]">
                                Pakendatud kogus KASTE
                            </td>
                            <td v-else :style="[css.td, css.paddingBig, css.colorGray]">Toodetud kogus KASTE</td>

                            <td colspan="9" :style="[css.td, css.paddingBig, css.colorYellow]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="activeWorkOrder.total_pallets_produced"
                                    @input="updateWorkOrder($event, 'total_pallets_produced')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    @focusout="handleTotalPalletsProducedFocusout"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>
                                    {{
                                        isPdfView && !activeWorkOrder.total_pallets_produced
                                            ? ""
                                            : activeWorkOrder.total_pallets_produced || "-"
                                    }}
                                </span>
                            </td>
                        </template>

                        <template v-if="(isToasterLineNumber && !isToasterWithPackingWorkOrder) || isFryerOnlyWorkOrder || (index > 1 && isFryerWithPackingWorkOrder)">
                            <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">POOLTOODET KOKKU, KG</td>
                            <td colspan="3" :style="[css.td, css.paddingBig, css.colorYellow]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="activeWorkOrder.intermediate_product_total_weight"
                                    @input="updateWorkOrder($event, 'intermediate_product_total_weight')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    step="1"
                                    @keypress="onlyIntegersWithComma"
                                ></v-text-field>
                                <span v-else>{{
                                        isPdfView && !activeWorkOrder.intermediate_product_total_weight
                                                ? ""
                                                : activeWorkOrder.intermediate_product_total_weight || "-"
                                    }}</span>
                            </td>
                        </template>
                        <template v-else>
                            <td :style="[css.td, css.paddingBig, css.colorGray]">+ Pakid</td>
                            <td colspan="1" :style="[css.td, css.paddingBig, css.colorYellow]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="activeWorkOrder.extra_bags_produced"
                                    @input="updateWorkOrder($event, 'extra_bags_produced')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    @focusout="handleTotalPalletsProducedFocusout"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>{{ activeWorkOrder.extra_bags_produced || "" }}</span>
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray]" colspan="2">
                                <span>{{ activeWorkOrder.produced_pallets_pcs || "" }}</span>
                            </td>

                            <td :style="[css.td, css.paddingBig, css.colorGray]">ALUSEID TK</td>
                        </template>
                    </tr>
                    <tr :style="[css.tr]">
                        <td colspan="12"></td>
                        <!-- For isFryerWithPackingWorkOrder second copy page we do not need this -->
                        <td
                            v-if="(!isToasterLineNumber || isToasterWithPackingWorkOrder) && !isFryerOnlyWorkOrder && !isFryerWithPackingWorkOrderSecondPage(index)"
                            :style="[css.td, css.paddingBig, css.colorGray]"
                            colspan="2"
                        >
                            <span>{{ activeWorkOrder.produced_boxes_pcs }}</span>
                        </td>
                        <td
                            v-if="(!isToasterLineNumber || isToasterWithPackingWorkOrder) && !isFryerOnlyWorkOrder && !isFryerWithPackingWorkOrderSecondPage(index)"
                            :style="[css.td, css.paddingBig, css.colorGray]"
                        >
                            KASTE TK
                        </td>
                    </tr>
                    <tr :style="[css.tr]">
                        <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Tootmise algusaeg</td>
                        <td :style="[css.td, css.paddingBig, css.colorYellow, css.minWidth70]" colspan="3">
                            <time-input
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                v-model="activeWorkOrder.exchange_report_start_time"
                            />
                            <span v-else>
                                {{
                                    isPdfView && !activeWorkOrder.exchange_report_start_time
                                        ? ""
                                        : activeWorkOrder.exchange_report_start_time || "00:00"
                                }}
                            </span>
                        </td>

                        <td colspan="2"></td>
                        <td colspan="2" :style="[css.td, css.paddingBig, css.colorGray]">Vahetusraporti lõpu kellaaeg</td>
                        <td :style="[css.td, css.paddingBig, css.colorYellow, css.minWidth100]">
                            <time-input
                                v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                v-model="activeWorkOrder.exchange_report_end_time"
                            />
                            <span v-else>
                                {{
                                    isPdfView && !activeWorkOrder.exchange_report_end_time
                                        ? ""
                                        : activeWorkOrder.exchange_report_end_time || "00:00"
                                }}
                            </span>
                        </td>
                        <td colspan="2" :style="[css.paddingBig]"></td>
                        <td
                            v-if="(!isToasterLineNumber || isToasterWithPackingWorkOrder) && !isFryerOnlyWorkOrder && !isFryerWithPackingWorkOrderSecondPage(index)"
                            :style="[css.td, css.paddingBig, css.colorGray]"
                            colspan="2"
                        >
                            <span>{{ activeWorkOrder.produced_bags_pcs || "" }}</span>
                        </td>
                        <td
                            v-if="(!isToasterLineNumber || isToasterWithPackingWorkOrder) && !isFryerOnlyWorkOrder  && !isFryerWithPackingWorkOrderSecondPage(index)"
                            :style="[css.td, css.paddingBig, css.colorGray]"
                        >
                            PAKKE TK
                        </td>
                    </tr>
                </tbody>
            </table>

            <template v-if="!isPdfView">
                <table v-if="isMultiLineOrder" :style="[css.workOrderTable]" style="width: 100%" class="mt-4">
                    <tbody>
                        <tr :style="[css.tr]">
                            TOOTMINE
                        </tr>

                        <tr :style="[css.tr]" v-if="activeWorkOrder && activeWorkOrder.wastes_secondary">
                            <td
                                :style="[css.td, css.paddingBig, css.colorGray, css.width100]"
                                :rowspan="
                                    activeWorkOrder &&
                                    activeWorkOrder.wastes_secondary &&
                                    activeWorkOrder.wastes_secondary.length > 0
                                        ? 1 + activeWorkOrder.wastes_secondary.length
                                        : editMode
                                        ? 1
                                        : 6
                                "
                            >
                                Jäätmed
                            </td>

                            <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]" colspan="2">Tüüp</td>
                            <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]" colspan="12">Kogus (kg)</td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn
                                    dark
                                    small
                                    color="bal-red"
                                    class="px-1 ml-1"
                                    style="min-width: 0"
                                    @click.stop="addNewWaste(WorkOrderCategories.CATEGORY_SECONDARY)"
                                >
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </td>
                        </tr>

                        <tr
                            :style="[css.tr]"
                            v-if="
                                !editMode &&
                                activeWorkOrder &&
                                activeWorkOrder.wastes_secondary &&
                                activeWorkOrder.wastes_secondary.length === 0
                            "
                            v-for="item in 5"
                        >
                            <td colspan="2" :style="[css.td, css.paddingBig, css.textLeft, css.colorYellow]"></td>
                            <td :style="[css.td, css.paddingBig, css.colorYellow, css.textLeft]" colspan="12"></td>
                        </tr>

                        <tr
                            :style="[css.tr]"
                            v-if="activeWorkOrder && activeWorkOrder.wastes_secondary"
                            v-for="(item, wasteIndex) in activeWorkOrder.wastes_secondary"
                        >
                            <td colspan="2" :style="[css.td, css.paddingBig, css.textLeft, css.colorYellow]">
                                <v-autocomplete
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="item.reason"
                                    @input="
                                        updateWorkOrderLineWaste(
                                            $event,
                                            wasteIndex,
                                            'reason',
                                            WorkOrderCategories.CATEGORY_SECONDARY
                                        )
                                    "
                                    item-text="name"
                                    item-value="value"
                                    :items="waffleWastes"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-autocomplete>
                                <span v-else>{{ item.reason || "" }}</span>
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorYellow, css.textLeft]" colspan="12">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="item.quantity"
                                    @input="
                                        updateWorkOrderLineWaste(
                                            $event,
                                            wasteIndex,
                                            'quantity',
                                            WorkOrderCategories.CATEGORY_SECONDARY
                                        )
                                    "
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @keypress="onlyIntegersWithComma"
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ item.quantity || "" }}</span>
                            </td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn
                                    icon
                                    @click="
                                        removeWaste({ index: wasteIndex, category: WorkOrderCategories.CATEGORY_SECONDARY })
                                    "
                                >
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </td>
                        </tr>

                        <tr :style="[css.tr]">
                            <td colspan="15"></td>
                        </tr>

                        <tr :style="[css.tr]" v-if="activeWorkOrder && activeWorkOrder.downtimes_and_breakdowns_secondary">
                            <td
                                colspan="2"
                                :style="[css.td, css.paddingBig, css.colorGray, css.paddingSmall, css.width100]"
                            >
                                Seisakute ja Rikete põhjused
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]">Aeg min.</td>
                            <td colspan="12" :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]">Märkused</td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn
                                    dark
                                    small
                                    color="bal-red"
                                    class="px-1 ml-1"
                                    style="min-width: 0"
                                    @click.stop="addNewDowntimeAndBreakdown(WorkOrderCategories.CATEGORY_SECONDARY)"
                                >
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        <tr
                            :style="[css.tr]"
                            v-if="activeWorkOrder && activeWorkOrder.downtimes_and_breakdowns_secondary"
                            v-for="(dab, dabIndex) in activeWorkOrder.downtimes_and_breakdowns_secondary"
                            :key="`downtimes_and_breakdowns_secondary_${dab.id}`"
                        >
                            <td :colspan="2" :style="[css.td, css.paddingBig, css.textLeft]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="dab.reason"
                                    @input="
                                        updateWorkOrderDowntimesAndBreakdowns(
                                            $event,
                                            dabIndex,
                                            'reason',
                                            WorkOrderCategories.CATEGORY_SECONDARY
                                        )
                                    "
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>{{ dab.reason || "" }}</span>
                            </td>
                            <td :style="[css.td, css.colorBlue, css.paddingBig, css.textLeft, css.colorYellow]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="dab.time_in_minutes"
                                    @input="
                                        updateWorkOrderDowntimesAndBreakdowns(
                                            $event,
                                            dabIndex,
                                            'time_in_minutes',
                                            WorkOrderCategories.CATEGORY_SECONDARY
                                        )
                                    "
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @keypress="onlyIntegersWithComma"
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ dab.time_in_minutes || "" }}</span>
                            </td>
                            <td colspan="12" :style="[css.td, css.colorYellow, css.paddingBig, css.textLeft]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="dab.notes"
                                    @input="
                                        updateWorkOrderDowntimesAndBreakdowns(
                                            $event,
                                            dabIndex,
                                            'notes',
                                            WorkOrderCategories.CATEGORY_SECONDARY
                                        )
                                    "
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>{{ dab.notes || "" }}</span>
                            </td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn
                                    icon
                                    @click="
                                        removeDowntimeAndBreakdown({
                                            index: dabIndex,
                                            category: WorkOrderCategories.CATEGORY_SECONDARY,
                                        })
                                    "
                                >
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        <tr
                            v-if="
                                !editMode &&
                                isPdfView &&
                                activeWorkOrder &&
                                activeWorkOrder.downtimes_and_breakdowns_secondary &&
                                activeWorkOrder.downtimes_and_breakdowns_secondary.length < 5
                            "
                            v-for="item in 5 - activeWorkOrder.downtimes_and_breakdowns_secondary.length"
                            :key="`dab_${item}`"
                            :style="[css.tr]"
                        >
                            <td colspan="2" :style="[css.td, css.paddingBig, css.textLeft]"></td>
                            <td :style="[css.td, css.paddingBig, css.textLeft, css.colorYellow]"></td>
                            <td colspan="12" :style="[css.td, css.paddingBig, css.colorYellow, css.textLeft]"></td>
                        </tr>
                        <tr :style="[css.tr]">
                            <td v-if="!editMode && isPdfView" :style="[css.td]" colspan="15">
                                Nädala viimase vahetusraportiga koos sisestatakse operaatori poolt ka metallidetektori
                                seirelehed!
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table v-if="isMultiLineOrder" :style="[css.workOrderTable]" style="width: 100%" class="mt-4">
                    <tbody>
                        <tr :style="[css.tr]">
                            PAKKIMINE
                        </tr>
                        <tr :style="[css.tr]" v-if="activeWorkOrder && activeWorkOrder.wastes">
                            <td
                                :style="[css.td, css.paddingBig, css.colorGray, css.width100]"
                                :rowspan="
                                    activeWorkOrder && activeWorkOrder.wastes && activeWorkOrder.wastes.length > 0
                                        ? 1 + activeWorkOrder.wastes.length
                                        : editMode
                                        ? 1
                                        : 6
                                "
                            >
                                Jäätmed
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]" colspan="2">Tüüp</td>
                            <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]" colspan="12">Kogus (kg)</td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn
                                    dark
                                    small
                                    color="bal-red"
                                    class="px-1 ml-1"
                                    style="min-width: 0"
                                    @click.stop="addNewWaste"
                                >
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </td>
                        </tr>

                        <tr
                            :style="[css.tr]"
                            v-if="
                                !editMode &&
                                activeWorkOrder &&
                                activeWorkOrder.wastes &&
                                activeWorkOrder.wastes.length === 0
                            "
                            v-for="item in 5"
                        >
                            <td colspan="2" :style="[css.td, css.paddingBig, css.textLeft, css.colorYellow]"></td>
                            <td :style="[css.td, css.paddingBig, css.colorYellow, css.textLeft]" colspan="12"></td>
                        </tr>

                        <tr
                            :style="[css.tr]"
                            v-if="activeWorkOrder && activeWorkOrder.wastes"
                            v-for="(item, wasteIndex) in activeWorkOrder.wastes"
                        >
                            <td colspan="2" :style="[css.td, css.paddingBig, css.textLeft, css.colorYellow]">
                                <v-autocomplete
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="item.reason"
                                    @input="updateWorkOrderLineWaste($event, wasteIndex, 'reason')"
                                    item-text="name"
                                    item-value="value"
                                    :items="waffleWastes"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-autocomplete>
                                <span v-else>{{ item.reason || "" }}</span>
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorYellow, css.textLeft]" colspan="12">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="item.quantity"
                                    @input="updateWorkOrderLineWaste($event, wasteIndex, 'quantity')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @keypress="onlyIntegersWithComma"
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ item.quantity || "" }}</span>
                            </td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn icon @click="removeWaste({ index: wasteIndex })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </td>
                        </tr>

                        <tr :style="[css.tr]">
                            <td colspan="15"></td>
                        </tr>

                        <tr :style="[css.tr]" v-if="activeWorkOrder && activeWorkOrder.downtimes_and_breakdowns">
                            <td
                                colspan="2"
                                :style="[css.td, css.paddingBig, css.colorGray, css.paddingSmall, css.width100]"
                            >
                                Seisakute ja Rikete põhjused
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]">Aeg min.</td>
                            <td colspan="12" :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]">Märkused</td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn
                                    dark
                                    small
                                    color="bal-red"
                                    class="px-1 ml-1"
                                    style="min-width: 0"
                                    @click.stop="addNewDowntimeAndBreakdown"
                                >
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        <tr
                            :style="[css.tr]"
                            v-if="activeWorkOrder && activeWorkOrder.downtimes_and_breakdowns"
                            v-for="(dab, dabIndex) in activeWorkOrder.downtimes_and_breakdowns"
                            :key="`downtimes_and_breakdowns_${dab.id}`"
                        >
                            <td :colspan="2" :style="[css.td, css.paddingBig, css.textLeft]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="dab.reason"
                                    @input="updateWorkOrderDowntimesAndBreakdowns($event, dabIndex, 'reason')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>{{ dab.reason || "" }}</span>
                            </td>
                            <td :style="[css.td, css.colorBlue, css.paddingBig, css.textLeft, css.colorYellow]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="dab.time_in_minutes"
                                    @input="updateWorkOrderDowntimesAndBreakdowns($event, dabIndex, 'time_in_minutes')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @keypress="onlyIntegersWithComma"
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ dab.time_in_minutes || "" }}</span>
                            </td>
                            <td colspan="12" :style="[css.td, css.colorYellow, css.paddingBig, css.textLeft]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="dab.notes"
                                    @input="updateWorkOrderDowntimesAndBreakdowns($event, dabIndex, 'notes')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>{{ dab.notes || "" }}</span>
                            </td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn icon @click="removeDowntimeAndBreakdown({ index: dabIndex })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        <tr
                            v-if="
                                !editMode &&
                                isPdfView &&
                                activeWorkOrder &&
                                activeWorkOrder.downtimes_and_breakdowns &&
                                activeWorkOrder.downtimes_and_breakdowns.length < 5
                            "
                            v-for="item in 5 - activeWorkOrder.downtimes_and_breakdowns.length"
                            :key="`dab_${item}`"
                            :style="[css.tr]"
                        >
                            <td colspan="2" :style="[css.td, css.paddingBig, css.textLeft]"></td>
                            <td :style="[css.td, css.paddingBig, css.textLeft, css.colorYellow]"></td>
                            <td colspan="12" :style="[css.td, css.paddingBig, css.colorYellow, css.textLeft]"></td>
                        </tr>
                        <tr :style="[css.tr]">
                            <td v-if="!editMode && isPdfView" :style="[css.td]" colspan="15">
                                Nädala viimase vahetusraportiga koos sisestatakse operaatori poolt ka metallidetektori
                                seirelehed!
                            </td>
                        </tr>
                    </tbody>
                </table>
                <table v-else :style="[css.workOrderTable]" style="width: 100%" class="mt-4">
                    <tbody>
                        <tr :style="[css.tr]" v-if="activeWorkOrder && activeWorkOrder.wastes">
                            <td
                                :style="[css.td, css.paddingBig, css.colorGray, css.width100]"
                                :rowspan="
                                    activeWorkOrder && activeWorkOrder.wastes && activeWorkOrder.wastes.length > 0
                                        ? 1 + activeWorkOrder.wastes.length
                                        : editMode
                                        ? 1
                                        : 6
                                "
                            >
                                Jäätmed
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]" colspan="2">Tüüp</td>
                            <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]" colspan="12">Kogus (kg)</td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn
                                    dark
                                    small
                                    color="bal-red"
                                    class="px-1 ml-1"
                                    style="min-width: 0"
                                    @click.stop="addNewWaste"
                                >
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </td>
                        </tr>

                        <tr
                            :style="[css.tr]"
                            v-if="
                                !editMode &&
                                activeWorkOrder &&
                                activeWorkOrder.wastes &&
                                activeWorkOrder.wastes.length === 0
                            "
                            v-for="item in 5"
                        >
                            <td colspan="2" :style="[css.td, css.paddingBig, css.textLeft, css.colorYellow]"></td>
                            <td :style="[css.td, css.paddingBig, css.colorYellow, css.textLeft]" colspan="12"></td>
                        </tr>

                        <tr
                            :style="[css.tr]"
                            v-if="activeWorkOrder && activeWorkOrder.wastes"
                            v-for="(item, wasteIndex) in activeWorkOrder.wastes"
                        >
                            <td colspan="2" :style="[css.td, css.paddingBig, css.textLeft, css.colorYellow]">
                                <v-autocomplete
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="item.reason"
                                    @input="updateWorkOrderLineWaste($event, wasteIndex, 'reason')"
                                    item-text="name"
                                    item-value="value"
                                    :items="waffleWastes"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-autocomplete>
                                <span v-else>{{ item.reason || "" }}</span>
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorYellow, css.textLeft]" colspan="12">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="item.quantity"
                                    @input="updateWorkOrderLineWaste($event, wasteIndex, 'quantity')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @keypress="onlyIntegersWithComma"
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ item.quantity || "" }}</span>
                            </td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn icon @click="removeWaste({ index: wasteIndex })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </td>
                        </tr>

                        <tr :style="[css.tr]">
                            <td colspan="15"></td>
                        </tr>

                        <tr :style="[css.tr]" v-if="activeWorkOrder && activeWorkOrder.downtimes_and_breakdowns">
                            <td
                                colspan="2"
                                :style="[css.td, css.paddingBig, css.colorGray, css.paddingSmall, css.width100]"
                            >
                                Seisakute ja Rikete põhjused
                            </td>
                            <td :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]">Aeg min.</td>
                            <td colspan="12" :style="[css.td, css.paddingBig, css.colorGray, css.textLeft]">Märkused</td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn
                                    dark
                                    small
                                    color="bal-red"
                                    class="px-1 ml-1"
                                    style="min-width: 0"
                                    @click.stop="addNewDowntimeAndBreakdown"
                                >
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        <tr
                            :style="[css.tr]"
                            v-if="activeWorkOrder && activeWorkOrder.downtimes_and_breakdowns"
                            v-for="(dab, dabIndex) in activeWorkOrder.downtimes_and_breakdowns"
                            :key="`downtimes_and_breakdowns_${dab.id}`"
                        >
                            <td :colspan="2" :style="[css.td, css.paddingBig, css.textLeft]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="dab.reason"
                                    @input="updateWorkOrderDowntimesAndBreakdowns($event, dabIndex, 'reason')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>{{ dab.reason || "" }}</span>
                            </td>
                            <td :style="[css.td, css.colorBlue, css.paddingBig, css.textLeft, css.colorYellow]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="dab.time_in_minutes"
                                    @input="updateWorkOrderDowntimesAndBreakdowns($event, dabIndex, 'time_in_minutes')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                    @keypress="onlyIntegersWithComma"
                                    step="1"
                                ></v-text-field>
                                <span v-else>{{ dab.time_in_minutes || "" }}</span>
                            </td>
                            <td colspan="12" :style="[css.td, css.colorYellow, css.paddingBig, css.textLeft]">
                                <v-text-field
                                    v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))"
                                    :value="dab.notes"
                                    @input="updateWorkOrderDowntimesAndBreakdowns($event, dabIndex, 'notes')"
                                    dense
                                    hide-details
                                    flat
                                    class="text-field-item"
                                    solo-inverted
                                ></v-text-field>
                                <span v-else>{{ dab.notes || "" }}</span>
                            </td>
                            <td v-if="editMode && roles && (roles.includes(roleSA) || roles.includes(roleOperator))">
                                <v-btn icon @click="removeDowntimeAndBreakdown({ index: dabIndex })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        <tr
                            v-if="
                                !editMode &&
                                isPdfView &&
                                activeWorkOrder &&
                                activeWorkOrder.downtimes_and_breakdowns &&
                                activeWorkOrder.downtimes_and_breakdowns.length < 5
                            "
                            v-for="item in 5 - activeWorkOrder.downtimes_and_breakdowns.length"
                            :key="`dab_${item}`"
                            :style="[css.tr]"
                        >
                            <td colspan="2" :style="[css.td, css.paddingBig, css.textLeft]"></td>
                            <td :style="[css.td, css.paddingBig, css.textLeft, css.colorYellow]"></td>
                            <td colspan="12" :style="[css.td, css.paddingBig, css.colorYellow, css.textLeft]"></td>
                        </tr>
                        <tr :style="[css.tr]">
                            <td v-if="!editMode && isPdfView" :style="[css.td]" colspan="15">
                                Nädala viimase vahetusraportiga koos sisestatakse operaatori poolt ka metallidetektori
                                seirelehed!
                            </td>
                        </tr>
                    </tbody>
                </table>
            </template>
            <table :style="[css.workOrderTable]" style="margin-top: 12px; width: 100%" v-if="isPdfView">
                <tbody>
                    <tr :style="[css.tr]">
                        <td :style="[css.td]">
                            Nädala viimase vahetusraportiga koos sisestatakse operaatori poolt ka metallidetektori
                            seirelehed!
                        </td>
                    </tr>
                </tbody>
            </table>
        </span>
        <work-order-view-table-printing
            v-if="!editMode && isPdfView && activeWorkOrder"
            :work-order="activeWorkOrder"
        />
    </span>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import moment from "moment";
import WorkOrderViewTablePrinting from "@/pages/work-order/table/work-order-view-table-printing.vue";
import TimeInput from "@/components/time-input.vue";
import { PermissionsConstants } from "@/permissions";
import { WORK_ORDER_CATEGORIES } from "../../../constants/workOrder";

export default {
    name: "work-order-view-table",
    components: { TimeInput, WorkOrderViewTablePrinting },
    props: {
        roles: {
            default: null,
            type: Array,
        },
        editMode: {
            default: true,
            type: Boolean,
        },
        isPdfView: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            test: "dsa",
            waffleWastes: [
                { name: "Vahvlivann", value: "Vahvlivann" },
                { name: "Segu", value: "Segu" },
                { name: "Pooltoode", value: "Pooltoode" },
                { name: "Kile", value: "Kile" },
                { name: "Tera", value: "Tera" },
            ],
            exchangeReportEndTime: null,
            productionDate: null,
            time: null,
            roleOperator: PermissionsConstants.ROLE_OPERATOR,
            roleHOS: PermissionsConstants.ROLE_HEAD_OF_SHIFT,
            roleSA: PermissionsConstants.ROLE_SUPERADMIN,
            roleLineWorker: PermissionsConstants.ROLE_LINE_WORKER,
            userStatusActive: "active",
            numberOfMixes: null,
            trueFalseItems: [
                {
                    text: "Jah",
                    value: true,
                },
                {
                    text: "Ei",
                    value: false,
                },
            ],
            css: {
                workOrderTable: {
                    width: "1082px",
                    borderCollapse: "collapse",
                    fontWeight: "bold",
                    textAlign: "center",
                    fontFamily: "Calibri, sans-serif",
                    fontSize: "12px",
                },
                tr: {
                    pageBreakInside: "avoid !important",
                },
                td: {
                    border: "1px solid black",
                    borderCollapse: "collapse",
                    padding: "2px",
                    fontSize: "12px",
                },
                hidden: {
                    display: "none",
                },
                paddingBig: {
                    padding: "8px",
                    height: "35px",
                },
                paddingExtraBig: {
                    padding: "16px",
                    height: "45px",
                },
                colorPurple: {
                    fontSize: "14px",
                    backgroundColor: "#f7cefc",
                },
                colorPurpleIngredientTable: {
                    fontSize: "13px",
                    backgroundColor: "#f7cefc",
                },
                colorGray: {
                    backgroundColor: "#d9d9d9",
                },
                colorBlue: {
                    backgroundColor: "#e0eaf6",
                },
                colorOrange: {
                    fontSize: "14px",
                    backgroundColor: "#f7cea0",
                },
                colorYellow: {
                    fontSize: "14px",
                    backgroundColor: "#fdf3d0",
                },
                textLeft: {
                    textAlign: "left",
                },
                minWidth70: {
                    minWidth: "50px",
                },
                minWidth100: {
                    minWidth: "80px",
                },
                width100: {
                    width: "80px",
                },
                width50: {
                    width: "40px",
                },
                width200: {
                    width: "160px",
                },
            },
        };
    },
    computed: {
        ...mapState("WorkOrderStore", ["activeWorkOrder", "users", "products", "materials", "workOrderLineNumbers"]),
        ...mapGetters("WorkOrderStore", [
            "isToasterWorkOrder",
            "isToasterLineNumber",
            "isPackingLineNumber",
            "isToasterWithPackingWorkOrder",
            "isFryerWithPackingWorkOrder",
            "isMultiLineOrder",
            "isFryerOnlyWorkOrder",
            "isToaster1LineNumber",
            "isToaster2LineNumber",
        ]),
        pageCount() {
            return this.isPdfView && this.isFryerWithPackingWorkOrder ? 2 : 1;
        },
        productionDateValue() {
            return this.getProductionDate();
        },
        estimatedTime() {
            return (type) => {
                return type === "long" ? this.getEstimationTime("long") : this.getEstimationTime("short");
            };
        },
        isRecipeRs16Case() {
            return !this.isToasterLineNumber && !this.isPackingLineNumber && !this.containsSeaSaltIngredient;
        },
        isRecipeRs17Case() {
            return !this.isToasterLineNumber && !this.isPackingLineNumber && this.containsSeaSaltIngredient;
        },
        containsSeaSaltIngredient() {
            return this.activeWorkOrder.ingredients.some((ingredient) => ingredient.product_code === "8211");
        },
        primaryOperator() {
            return this.activeWorkOrder.operators.find(
                (op) => op.category === this.WorkOrderCategories.CATEGORY_PRIMARY
            );
        },
        secondaryOperator() {
            return this.activeWorkOrder.operators.find(
                (op) => op.category === this.WorkOrderCategories.CATEGORY_SECONDARY
            );
        },
        studentOperators() {
            return this.activeWorkOrder.operators.filter(
                (op) => op.category === this.WorkOrderCategories.CATEGORY_STUDENT
            );
        },
        WorkOrderCategories() {
            return WORK_ORDER_CATEGORIES;
        },
        fryerWithPackingLineNumbers() {
            return this.workOrderLineNumbers.filter((line) => {
                const v = line.value.toLowerCase();
                return v.includes("fryer") && v.includes("+") && v.includes("polaris");
            });
        },
    },
    created() {
        if (this.isPdfView) {
            this.css.paddingBig.padding = "4px";
            this.css.paddingBig.height = "20px";
        }
    },
    async mounted() {
        this.time = this.activeWorkOrder.exchange_report_end_time || null;
        this.numberOfMixes = this.activeWorkOrder.number_of_mixes || null;
    },
    watch: {
        time() {
            this.updateWorkOrder(this.time, "exchange_report_end_time");
        },
        productionDate() {
            if (this.productionDate !== "-") {
                this.updateProductionDateTime("date");
            }
        },
    },
    methods: {
        ...mapMutations("WorkOrderStore", [
            "updateActiveWorkOrderProperty",
            "updateActiveWorkOrderIngredientProperty",
            "updateActiveWorkOrderLineWorkerProperty",
            "updateActiveWorkOrderOperatorProperty",
            "updateActiveWorkOrderWasteProperty",
            "addNewLineWorker",
            "addNewOperator",
            "removeLineWorker",
            "removeOperator",
            "addNewIngredient",
            "removeIngredient",
            "addNewWaste",
            "removeWaste",
            "updateActiveWorkOrderProductProperty",
            "updateActiveWorkOrderDowntimesAndBreakdownsProperty",
            "removeDowntimeAndBreakdown",
            "addNewDowntimeAndBreakdown",
        ]),
        ...mapActions("WorkOrderStore", ["fetchWorkOrders"]),
        isFryerWithPackingWorkOrderSecondPage(index) {
            return index === 2 && this.isFryerWithPackingWorkOrder;
        },
        generatePdf() {
            this.$refs.html2Pdf.generatePdf();
        },
        lineWorkerOptions(lineWorker) {
            const active = this.users
                .filter((u) => u.work_roles?.includes(this.roleLineWorker) && u.status === this.userStatusActive)
                .map((u) => ({ ...u, disabled: false }));

            const selected = this.users.find((u) => u.name === lineWorker.name);

            if (selected && !active.find((u) => u.name === selected.name)) {
                active.unshift({ ...selected, disabled: true });
            }

            return active;
        },
        operatorOptions(selectedOperator) {
            const active = this.users
                .filter(
                    (u) =>
                        u.work_roles?.some((r) => [this.roleOperator, this.roleHOS].includes(r)) &&
                        u.status === this.userStatusActive
                )
                .map((u) => ({ ...u, disabled: false }));

            const selected = this.users.find((u) => u.name === selectedOperator?.name);

            if (selected && !active.find((u) => u.name === selected.name)) {
                active.unshift({ ...selected, disabled: true });
            }

            return active;
        },
        getProductionDate() {
            if (!this.activeWorkOrder.production_date) {
                return moment().format("DD/MM/YYYY");
            }

            return moment(this.activeWorkOrder.production_date).format("DD/MM/YYYY");
        },
        getProductionStartTime() {
            if (!this.activeWorkOrder.production_date) {
                return "-";
            }
            return moment(this.activeWorkOrder.production_date).format("HH:mm:ss");
        },
        getEstimationTime(type, isString = false) {
            if (!this.activeWorkOrder.estimated_time) {
                return "-";
            }
            let hours = null;
            let minutes = null;
            let seconds = null;

            if (isString) {
                let result = this.activeWorkOrder.estimated_time.match(/\b([\d]*)\b/g);

                if (result.length !== 4) return "-";
                if (!result[0] || !result[2]) return "-";

                minutes = parseInt(result[0]);
                seconds = result[2];
                hours = parseInt(minutes / 60);

                if (hours) {
                    minutes -= hours * 60;
                }
            } else {
                let time = moment(this.activeWorkOrder.estimated_time, "HH:mm:ss");
                hours = time.hours();
                minutes = time.minutes();
                seconds = time.seconds();
            }

            if (type === "long") {
                return `${hours}h${minutes}min${seconds}sek`;
            } else {
                return `${hours * 60 + minutes}:${seconds}`;
            }
        },
        updateWorkOrder(value, field) {
            if (
                [
                    "boxes_on_pallet",
                    "bags_in_box",
                    "planned_quantity",
                    "planned_quantity_secondary",
                    "produced_bags_pcs",
                    "produced_boxes_pcs",
                    "produced_pallets_pcs",
                    "intermediate_product_bag_weight",
                    "intermediate_product_bags_produced",
                    "intermediate_product_total_weight",
                ].includes(field) &&
                value
            ) {
                value = value.replace(",", ".");
            }

            this.updateActiveWorkOrderProperty({ field, value });
        },
        updateWorkOrderIngredient(value, field, index) {
            if (["estimated_quantity", "actual_quantity"].includes(field) && value) {
                value = value.replace(",", ".");
            }
            if (
                this.activeWorkOrder.ingredients[index].product_unit === "tk" &&
                ["actual_quantity"].includes(field) &&
                value
            ) {
                value = Math.ceil(parseFloat(value));
            }
            this.updateActiveWorkOrderIngredientProperty({ field, value, index });
            this.$forceUpdate();
        },
        updateWorkOrderLineWorker(value, field, index) {
            this.updateActiveWorkOrderLineWorkerProperty({ field, value, index });
        },
        updateWorkOrderResponsibleOperator(value, field, index, category = this.WorkOrderCategories.CATEGORY_PRIMARY) {
            this.updateActiveWorkOrderOperatorProperty({ field, value, index, category });
        },
        updateWorkOrderLineWaste(value, index, field, category = this.WorkOrderCategories.CATEGORY_PRIMARY) {
            if (["quantity"].includes(field) && value) {
                value = value.replace(",", ".");
            }
            this.updateActiveWorkOrderWasteProperty({ value, index, field, category });
        },
        updateWorkOrderDowntimesAndBreakdowns(
            value,
            index,
            field,
            category = this.WorkOrderCategories.CATEGORY_PRIMARY
        ) {
            if (["time_in_minutes"].includes(field) && value) {
                value = value.replace(",", ".");
                value = value.replace(/[^0-9.]/g, "");
            }

            this.updateActiveWorkOrderDowntimesAndBreakdownsProperty({ value, index, field, category });
        },
        updateWorkOrderProduct(product_name) {
            this.updateActiveWorkOrderProductProperty({ product_name });
        },
        updateProductionDateTime(dateTimePart) {
            const newDateTime = new Date(this.activeWorkOrder.production_date);
            let month = (newDateTime.getMonth() + 1).toString().padStart(2, "0");
            const formattedDateTimeString = `${newDateTime.getFullYear()}-${month}-${newDateTime.getDate()} ${newDateTime.getHours()}:${newDateTime.getMinutes()}:00`;
            let newFormattedDateTimeString;
            if (dateTimePart === "date") {
                let newDateString;
                if (this.productionDate.includes("/")) {
                    newDateString = this.productionDate.split("/").reverse().join("-");
                } else {
                    newDateString = this.productionDate;
                }
                const parts = formattedDateTimeString.split(" ");
                newFormattedDateTimeString = `${newDateString} ${parts[1]}`;
                this.productionDate = newDateString;
            }

            this.updateWorkOrder(newFormattedDateTimeString, "production_date");
        },
        getName(value) {
            if (!value) {
                return "-";
            }

            if (typeof value === "object" && value.name) {
                return value.name;
            } else if (typeof value === "string") {
                return value;
            }

            return value;
        },
        onlyIntegersWithComma($event) {
            let keyCode = $event.keyCode ? $event.keyCode : $event.key;
            if (keyCode < 44 || keyCode === 47 || keyCode === 45 || keyCode > 57) {
                $event.preventDefault();
            }
        },
        // calculateColspanLength(index, items) {
        //     const totalCols = 14;
        //     const itemsLen = items.length || 1;
        //
        //     if (totalCols % itemsLen === 0) {
        //         return totalCols / itemsLen;
        //     }
        //
        //     const baseColspan = Math.floor(totalCols / itemsLen);
        //     const itemsWithBaseColspan = totalCols % itemsLen;
        //     const baseColspanStartIndex = itemsWithBaseColspan * (baseColspan + 1);
        //
        //     if (index < baseColspanStartIndex) {
        //         return baseColspan + 1;
        //     }
        //     return baseColspan;
        // },

        calculateColspanLength(index, items, totalCols=9) {
            const itemsLen = items.length;

            if (totalCols % itemsLen === 0) {
                return totalCols / itemsLen;
            }

            const baseSize = Math.floor(totalCols / itemsLen);
            const remainder = totalCols % itemsLen;

            if (index < remainder) {
                return baseSize + 1;
            } else {
                return baseSize;
            }
        },
        handleRemoveLineWorker(index) {
            if (confirm(this.t("Remove line worker?"))) {
                this.removeLineWorker(index);
            }
        },
        handleRemoveOperator(index) {
            if (confirm(this.t("Remove operator?"))) {
                this.removeOperator(index);
            }
        },
        addNewStudentOperator() {
            if (this.studentOperators.length >= 2) {
                return;
            }
            this.addNewOperator(this.WorkOrderCategories.CATEGORY_STUDENT);
        },
        handleRemoveStudentOperator(index) {
            if (confirm(this.t("Remove student operator?"))) {
                const studentOperatorIndex = this.activeWorkOrder.operators.findIndex(
                    (op, idx) => op.category === this.WorkOrderCategories.CATEGORY_STUDENT &&
                    this.activeWorkOrder.operators.filter((o, i) => i <= idx && o.category === this.WorkOrderCategories.CATEGORY_STUDENT).length === index + 1
                );
                if (studentOperatorIndex !== -1) {
                    this.removeOperator(studentOperatorIndex);
                }
            }
        },
        updateWorkOrderStudentOperator(value, field, index) {
            const studentOperatorIndex = this.activeWorkOrder.operators.findIndex(
                (op, idx) => op.category === this.WorkOrderCategories.CATEGORY_STUDENT &&
                this.activeWorkOrder.operators.filter((o, i) => i <= idx && o.category === this.WorkOrderCategories.CATEGORY_STUDENT).length === index + 1
            );
            if (studentOperatorIndex !== -1) {
                this.updateActiveWorkOrderOperatorProperty({ field, value, index: studentOperatorIndex, category: this.WorkOrderCategories.CATEGORY_STUDENT });
            }
        },
        handleRemoveIngredient(index) {
            if (confirm(this.t("Remove ingredient?"))) {
                this.removeIngredient(index);
            }
        },
        handleTotalPalletsProducedFocusout() {
            if (!this.activeWorkOrder.total_pallets_produced) {
                return;
            }

            const root = this.activeWorkOrder.total_pallets_produced.split("+");
            const boxesSum = root.reduce((total, numString) => total + parseInt(numString), 0);

            if (!boxesSum) {
                return;
            }

            const fullPallet = this.activeWorkOrder.boxes_on_pallet;
            const fullBox = this.activeWorkOrder.bags_in_box;

            if (!fullPallet || !fullBox || fullPallet === "0" || fullBox === "0") {
                return;
            }

            let bags = boxesSum * fullBox;

            if (this.activeWorkOrder.extra_bags_produced) {
                bags += parseInt(this.activeWorkOrder.extra_bags_produced);
            }

            let sumString = this.activeWorkOrder.total_pallets_produced.replace(/\s/g, "");

            this.updateWorkOrder(bags.toString(), "produced_bags_pcs");
            this.updateWorkOrder(boxesSum.toString(), "produced_boxes_pcs");
            this.updateWorkOrder((boxesSum / fullPallet).toString(), "produced_pallets_pcs");
            this.updateWorkOrder(sumString, "total_pallets_produced");
        },
        handleIntermediateProductsProducedFocusout() {
            if (
                !this.activeWorkOrder.intermediate_product_bags_produced ||
                !this.activeWorkOrder.intermediate_product_bag_weight
            ) {
                return;
            }
            const root = this.activeWorkOrder.intermediate_product_bags_produced.split("+");
            const bagsSum = root.reduce((total, numString) => total + parseInt(numString), 0);
            if (!bagsSum) return;

            const bagWeight = parseFloat(this.activeWorkOrder.intermediate_product_bag_weight);
            if (!bagWeight || bagWeight === "0") return;

            const bags = Math.round(bagsSum * bagWeight * 1000) / 1000;
            let sumString = this.activeWorkOrder.intermediate_product_bags_produced.replace(/\s/g, "");
            this.updateWorkOrder(bags.toString(), "intermediate_product_total_weight");
            this.updateWorkOrder(sumString, "intermediate_product_bags_produced");
        },
        batchChangeTimeCellCss(index) {
            const ingredients = this.activeWorkOrder.ingredients;
            if (ingredients[index].batch_change_time !== null) {
                return [this.css.td, this.css.colorYellow];
            } else if (
                index !== 0 &&
                ingredients[index - 1].batch_change_time !== null &&
                ingredients[index - 1].product_code === ingredients[index].product_code
            ) {
                return [this.css.hidden];
            } else {
                return [this.css.td];
            }
        },
        batchChangeTimeCellRowspan(index) {
            const ingredients = this.activeWorkOrder.ingredients;
            if (
                ingredients[index].batch_change_time !== null &&
                index < ingredients.length - 1 &&
                ingredients[index].product_code === ingredients[index + 1].product_code &&
                ingredients[index + 1].batch_change_time === null
            ) {
                return 2;
            } else {
                return 1;
            }
        },
        makeBatchChangeTimeEditable(index) {
            if (
                (this.roles.includes(this.roleSA) ||
                    this.roles.includes(this.roleOperator) ||
                    this.roles.includes(this.roleSA)) &&
                this.editMode &&
                !this.activeWorkOrder.ingredients[index].batch_change_time
            ) {
                this.activeWorkOrder.ingredients[index].batch_change_time = "00:00";
            }
        },
        deleteBatchChangeTime(index) {
            if (this.activeWorkOrder.ingredients[index].batch_change_time !== null) {
                this.activeWorkOrder.ingredients[index].batch_change_time = null;
            }
        },
        getLineNumberText(lineNumber) {
            const matchingItem = this.workOrderLineNumbers.find((item) => item.value === lineNumber);
            return matchingItem ? matchingItem.text : "-";
        },
        onNumberOfMixesChange() {
            if (this.isRecipeRs16Case === false && this.isRecipeRs17Case === false) return;

            this.updateWorkOrder(this.numberOfMixes, "number_of_mixes");

            const relatedIngredients = {
                8345: 5, // kartulihelbed
                8350: 5.6, // manna
                8348: 3.5, // tärklis
                8211: 0.52, // meresool
                8210: 0.084, // sool
            };

            this.activeWorkOrder.ingredients.forEach((ingredient, index) => {
                if (relatedIngredients.hasOwnProperty(ingredient.product_code)) {
                    const amount = (
                        Math.round(relatedIngredients[ingredient.product_code] * this.numberOfMixes * 1000) / 1000
                    ).toString();
                    this.updateWorkOrderIngredient(amount, "actual_quantity", index);
                }
            });
        },
        getPackingLineNumberText(lineNumber) {
            if (!lineNumber || !lineNumber.includes("+")) return "-";
            return lineNumber
                .split("+")
                .map((part) => {
                    if (part.startsWith("polaris_")) {
                        return part.replace("_", " ").replace(/\b\w/g, (c) => c.toUpperCase());
                    }
                    return null;
                })
                .filter(Boolean)
                .join(" + ");
        },
    },
};
</script>

<style scoped lang="scss">
.work-order-container2 {
    min-width: 1000px;
    overflow: scroll;
    width: 100%;

    .work-order-table {
        width: 100%;
        border-collapse: collapse;
        font-weight: bold;
        text-align: center;
        font-family: Calibri, sans-serif;
        font-size: 12px;

        td {
            border: 1px solid black;
            border-collapse: collapse;
            padding: 2px;
        }

        .padding-big {
            td {
                padding: 8px;
                height: 35px;
            }
        }

        .no-border {
            border-color: white;
        }

        .no-top-bottom-border {
            border-bottom: 0 solid white;
            border-top: 0 solid white;
        }

        .c-purple {
            font-size: 14px;
            background-color: #c302c4;
        }

        .c-orange {
            font-size: 14px;
            background-color: #f46302;
        }

        .c-yellow {
            font-size: 14px;
            background-color: #f4f403;
        }

        .c-gray {
            background-color: #cfcfcf;
        }

        .s-data-width {
            min-width: 70px;
        }
    }
}
</style>
